import packageJson from '../../../../package.json';

/**
 * Get the current application version from package.json
 * This utility function retrieves the version directly from the package.json file
 * @returns The current version string from package.json
 */
export function getCurrentVersion(): string {
  return packageJson.version;
}
